import { render, staticRenderFns } from "./LineItemDetails.vue?vue&type=template&id=0963d5e4&scoped=true"
import script from "./LineItemDetails.vue?vue&type=script&lang=js"
export * from "./LineItemDetails.vue?vue&type=script&lang=js"
import style0 from "./LineItemDetails.vue?vue&type=style&index=0&id=0963d5e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0963d5e4",
  null
  
)

export default component.exports